import React, { useState, useEffect } from "react";
export enum Size {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

interface IconSizeProps {
  initialSize?: Size;
  onSizeChange?: (size: Size) => void;
  className?: string;
}

const sizeOptions: { label: string; value: Size }[] = [
  { label: "Small", value: Size.Small },
  { label: "Medium", value: Size.Medium },
  { label: "Large", value: Size.Large },
];

const MarkerSize: React.FC<IconSizeProps> = ({
  initialSize = Size.Medium,
  onSizeChange,
  className = "",
}) => {
  const [selected, setSelected] = useState<Size>(initialSize);

  useEffect(() => {
    setSelected(initialSize);
  }, [initialSize]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = e.target.value as Size;
    setSelected(newSize);
    if (onSizeChange) {
      onSizeChange(newSize);
    }
  };

  return (
    <div
      className={`w-full max-w-xs mx-auto p-4 mb-4 bg-white shadow-lg rounded-lg flex flex-col space-y-2 ${className}`}
    >
      <label
        htmlFor="icon-size-select"
        className="block text-xs sm:text-sm md:text-base font-semibold text-gray-700"
      >
        Marker Size
      </label>
      <select
        id="icon-size-select"
        value={selected}
        onChange={handleChange}
        className="
          w-full
          rounded-lg
          border border-gray-300
          bg-white
          text-xs sm:text-sm md:text-base
          py-2 px-3
          focus:outline-none
          focus:ring-2 focus:ring-blue-400
          transition
        "
      >
        {sizeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
export default MarkerSize;
